<template>
    <div class="usersPage">
        <addButton></addButton>
        <router-view></router-view>

        <div class="userStuffHolder">
            <div class="userTop">
                <select class="userSortSelect" v-model="userSort">
                    <option value="id">id</option>
                    <option value="unum">unum</option>
                    <option value="fname">fname</option>
                    <option value="lname">lname</option>
                    <option value="stao">stao</option>
                </select>
                <input class="userSelectInput" type="text" v-model="filter"/>
            </div>

            <div class="userListHolder">
                <div v-for="item in userList"
                     :key="item.id"
                     class="userListElement"
                     @click="userInfo(item.id)"
                     v-show="!item.hidden"
                >
                    <div class="userTitle">
                        <p>{{item.unum}}</p>
                        <p>{{item.id}}</p>
                    </div>

                    {{item.fname}} {{item.lname}}<br>

                    <div class="userTitle">
                        <p>{{item.stao}}</p>
                        <p>{{item.autlev}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import addButton from './add-button';

export default {
    components: {
        addButton
    },
    data() {
        return {
            userSort: 'id',
            filter: ''
        }
    },
    computed: {
        userList() {
            return this.$store.getters['user/userList'];
        },
        staos() {
            return this.$store.getters['user/staos'];
        }
    },
    methods: {
        userInfo(id) {
            this.$store.dispatch('user/userInfo', id);
        }
    },
    watch: {
        userSort: function() {
            this.$store.dispatch('user/userList', { userSort: this.userSort });
        },
        filter: function() {
            let userString = '';

            if (this.filter.length > 0) {
                for (let i = 0; i < this.userList.length; i++) {
                    userString = this.userList[i].unum.toUpperCase() +
                            this.userList[i].fname.toUpperCase() +
                            this.userList[i].lname.toUpperCase() +
                            this.userList[i].stao.toUpperCase() +
                            this.userList[i].autlev.toUpperCase();

                    if (userString.includes(this.filter.toUpperCase())) {
                        this.userList[i].hidden = false;
                    } else {
                        this.userList[i].hidden = true;
                    }
                }
            } else {
                for (let i = 0; i < this.userList.length; i++) {
                    this.userList[i].hidden = false;
                }
            }
        }
    },
    created() {
        this.$store.dispatch('user/userList', { userSort: this.userSort });
    }
}
</script>

<style scoped lang="scss">
    .usersPage {
        position: absolute;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .userStuffHolder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .userTop {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 12.5rem;
    }

    .userSortSelect {
        height: 3rem;
        font-size: 2rem;
    }

    .userSelectInput {
        font-size: 1.5rem;
        width: 80%;
    }

    .userListHolder {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .userListElement {
        font-size: 1.5rem;
        padding: 0.375rem;
        cursor: pointer;
        border-bottom: 0.125rem solid black;
    }

    .userListElement:hover {
        background-color: $color-gray;
    }

    .userTitle {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

    }

    @include medium {

        .userStuffHolder {
            width: 31rem;
            @include default-shadow;
        }

    }

    @include extra-large {

        .userStuffHolder {
            width: 31rem;
            @include default-shadow;
            height: 90vh;
        }

        .userListElement {
            font-size: 2rem;
        }

        .userTop {
            height: 80px;
            flex-direction: row;

        }
    }
</style>
